import en from "../localizations/en.json";
import de from "../localizations/de.json";
import fr from "../localizations/fr.json";
import es from "../localizations/es.json";
import { createContext, useContext } from "react";
type TranslationsFunction = (text: string) => string;

interface TranslationContextType {
    translations: TranslationsFunction;
}

const TranslationContext = createContext<TranslationContextType>({
    translations: () => ""
});

export const useTranslations = () => useContext(TranslationContext);

export const TranslationProvider = ({ children }) => {

    const translations: TranslationsFunction = (text) => {
        const lang = localStorage.getItem("lang") || "en";

        if (lang === "en") {
            return en[text] ?? text;
        }

        if (lang === "de") {
            return de[text] ?? en[text] ?? text;
        }

        if (lang === "fr") {
            return fr[text] ?? en[text] ?? text;
        }

        if (lang === "es") {
            return es[text] ?? en[text] ?? text;
        }

        return en[text] ?? text;
    };


    return <TranslationContext.Provider value={{ translations }}>{children}</TranslationContext.Provider>;
};
